import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, FormControl, Dropdown } from "react-bootstrap";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import { FiPlus, FiSearch, FiMoreHorizontal } from "react-icons/fi";
import { errorFormating } from "utils/utils";
import ProviderEditModal from "components/Providers/ProviderEditModal";
import * as expensesActions from "actions/expensesActions";
import { showModal, hideModal } from "actions/modalActions";
import { providersService } from "services";
import Loading from "components/Loading";
import Layout from "components/Layout";
import Modal from "components/Modal";
import DataTable from "components/DataTable/DataTable";
import { withTranslation } from "react-i18next";
import "components/Providers/Providers.scss";

class Providers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchProvider: "",
		};
		this.closeModal = this.closeModal.bind(this);
		this.openDeleteProviderModal = this.openDeleteProviderModal.bind(this);
		this.openNewProviderModal = this.openNewProviderModal.bind(this);
		this.openEditProviderModal = this.openEditProviderModal.bind(this);
		this.getProviders = this.getProviders.bind(this);
	}

	componentDidMount() {
		this.getProviders();
	}

	handleChangeSearch = (event) => {
		const targetId = event.target.id;

		this.setState(
			{
				[targetId]: event.target.value,
			},
			() => {
				this.getProviders();
			}
		);
	};

	async getProviders() {
		await this.props.getAllProviders({
			q: this.state.searchProvider,
		});
	}

	closeModal() {
		this.props.hideModal();
	}

	openDeleteProviderModal(idProvider) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('providers.deleteProvider'),
				style: { width: "400px" },
				message: this.props.t('providers.deleteConfirmation'),
				deleteAction: () => this.confirmDelete(idProvider),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openEditProviderModal(provider) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('providers.editProvider'),
				style: { width: "700px" },
				content: (
					<ProviderEditModal
						provider={provider}
						getProviders={this.getProviders}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openNewProviderModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('providers.newProvider'),
				style: { width: "700px" },
				content: (
					<ProviderEditModal
						handleClose={this.closeModal}
						getProviders={this.getProviders}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(title, message) {
		this.props.showModal(
			{
				open: true,
				title: title,
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idProvider) => {
		const response = await providersService.remove(idProvider);
		this.closeModal();

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(this.props.t('providers.deleteError'), textError.id);
		} else {
			this.getProviders();
			this.closeModal();
		}
	};

	getActions = (provider) => (
		<Dropdown>
			<Dropdown.Toggle variant="action">
				<FiMoreHorizontal />
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item
					as="button"
					onClick={() => this.openEditProviderModal(provider)}
				>
					{this.props.t('common.edit')}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.openDeleteProviderModal(provider.id)}
				>
					{this.props.t('common.delete')}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getDesktopColumns = () => [
		{
			key: "name",
			header: this.props.t('common.name'),
			className: "td-name",
			render: (provider) => (
				<button
					className="btn-transparent btn-editable"
					onClick={() => this.openEditProviderModal(provider)}
				>
					{provider.name}
				</button>
			),
		},
		{
			key: "vat_number",
			header: this.props.t('providers.cif'),
		},
		{
			key: "address",
			header: this.props.t('providers.address'),
			render: (provider) => (
				<>
					{provider.address && (
						<span className="provider-address">{provider.address}</span>
					)}
					{provider.postal_code && (
						<span className="provider-postal-code">{provider.postal_code}</span>
					)}
				</>
			),
		},
		{
			key: "city",
			header: this.props.t('providers.city'),
			render: (provider) => (
				<>
					{provider.city && (
						<span className="provider-city">{provider.city}</span>
					)}
					{provider.country_iso && (
						<span className="provider-country">[{provider.country_iso}]</span>
					)}
				</>
			),
		},
		{
			key: "email",
			header: this.props.t('providers.emailPhone'),
			render: (provider) => (
				<>
					<span className="provider-email">{provider.email}</span>
					{provider.phone && (
						<span className="provider-phone">{provider.phone}</span>
					)}
				</>
			),
		},
	];

	getTableRowsMobile = () =>
		this.props.providers.map((provider) => (
			<tr key={provider.id}>
				<td className="td-name">{provider.name}</td>
				<td>{provider.vat_number}</td>
				<td className="td-actions">{this.getActions(provider)}</td>
			</tr>
		));

	getEmptyRow = () => {
		return <p>{this.props.t('common.noResults')}</p>;
	};

	getContent = () => {
		if (this.props.loading) {
			return <Loading />;
		}

		if (this.props.error) {
			return this.props.t('providers.errorLoading');
		}

		if (this.props.providers == undefined || this.props.providers.length === 0)
			return this.getEmptyRow();

		return (
			<>
				<Mobile>
					<div className="table-mobile-container">
						<table className="table table-providers table-mobile">
							<tbody>{this.getTableRowsMobile()}</tbody>
						</table>
					</div>
				</Mobile>
				<TabletOrDesktop>
					<DataTable
						tableClassName="table-providers table-desktop table-hover"
						columns={this.getDesktopColumns()}
						rows={this.props.providers}
						rowKey={(row) => row.id}
						emptyMessage={this.props.t('common.noResults')}
						actionsColumn={{
							render: (provider) => this.getActions(provider),
							className: "td-actions",
						}}
					/>
				</TabletOrDesktop>
			</>
		);
	};

	render() {
		return (
			<>
				<Layout
					className="page-providers"
					context="expenses"
					configSidebar={true}
				>
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{this.props.t('providers.title')}</h1>
						</div>
						<div className="heading-filters">
							<FormGroup className="form-search" controlId="searchProvider">
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.searchProvider}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>

						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t('providers.createProvider')}
								onClick={this.openNewProviderModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.expensesReducer,
		loading: reducers.expensesReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllProviders: (options) =>
		dispatch(expensesActions.getAllProviders(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Providers));
